export { default } from './AuthRegisterForm';
